import { ActionDefinitionDTO, DossierSituation, ProjectEntityDTO, ProjectStatusDTO } from '../../api/plyca-dtos-v2';
import { Injectable } from '@angular/core';
import { PlycaDataService } from '../../../services/plyca.service';
import { Configuration } from '../../conf/app.constants';
import { Observable } from 'rxjs';
import { PaginationDTO } from '../../api/PaginationModel';
import { ServiceLocator } from '../../ServiceLocator';
import { AppConfiguration } from '../../conf/app.configuration';


@Injectable()
export class DossierModelsService {
  appConfig: AppConfiguration;

  constructor(
    public plycaService: PlycaDataService,
    public configuration: Configuration
  ) {
    this.appConfig = ServiceLocator.injector.get(AppConfiguration);

  }

  getModels(situations: DossierSituation[], type?: string): Observable<PaginationDTO<ProjectEntityDTO>> {
    return this.getUserUOModels(situations, type, null);
  }

  getUserUOModels(situations: DossierSituation[], type?: string, userUO?: string): Observable<PaginationDTO<ProjectEntityDTO>> {
    let filter = {} as any;
    filter.documentClassId = this.appConfig.getValue('dossierModel.documentClass');

    //tipo de procedimiento
    if (type) {
      filter.type = type;
    }

    if (situations) {
      filter.situation = situations;
    }

    if (userUO) {
      filter.organizationalUnitId = userUO;
    }
    return this.plycaService.query<ProjectEntityDTO>(this.configuration.PROJECTENTITY_SERVICE_URL, filter);
  }

  public createDossierFromModel(model: any): Observable<any> {
    return this.plycaService.execAction(
      this.configuration.PROCUREMENTPROJ_SERVICE_URL,
      model.identifier,
      'CLONE_PROJECT_TENDERDEF'
    );
  }

  public createTenderDefFromModel(model: any, projectDestinationIdentifier: string): Observable<any> {
    let param: string = 'IMPORT_FLIC.TENDERDEF_PROJECT_DESTINATION=' + projectDestinationIdentifier;
    return this.plycaService.execAction(
      this.configuration.PROCUREMENTPROJ_SERVICE_URL,
      model.identifier,
      'IMPORT_FLIC',
      param
    );
  }

  public updateModelStatus(model: ProjectEntityDTO, situation: DossierSituation): Observable<any> {
    let clonedModel = {} as ProjectEntityDTO;
    clonedModel.identifier = model.identifier;
    clonedModel.status = new ProjectStatusDTO();
    clonedModel.status.situation = situation;
    return this.plycaService.patch<ProjectEntityDTO>(this.configuration.PROJECTENTITY_SERVICE_URL, clonedModel);
  }
}
